import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const cancelQuotationThunk = createAsyncThunk(
    `CancelQuotationSlicer/cancelQuotationThunk`,
    async (solicitation, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const body = {
            note: solicitation.note,
        };

        const { data } = await conciergeApiClient.post(
            `Redemption/${solicitation.solicitationId}/cancel`, body, { headers }
        );

        return data;
    }
);

const initialState = {
    dataCancelSolicitation: false,
    loadingCancelSolicitation: false,
    errorCancelSolicitation: false,
};

const CancelQuotationSlicer = createSlice({
    name: 'CancelQuotation',
    initialState,
    reducers: {
        resetDataCancelSolicitation: (state) => {
            state.dataCancelSolicitation = false;
            state.loadingCancelSolicitation = false;
            state.errorCancelSolicitation = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(cancelQuotationThunk.pending, (state) => {
            state.dataCancelSolicitation = false;
            state.loadingCancelSolicitation = true;
            state.errorCancelSolicitation = false;
        });
        builder.addCase(cancelQuotationThunk.fulfilled, (state, action) => {
            state.dataCancelSolicitation = true;
            state.loadingCancelSolicitation = false;
            state.errorCancelSolicitation = false;
        });
        builder.addCase(cancelQuotationThunk.rejected, (state) => {
            state.dataCancelSolicitation = false;
            state.loadingCancelSolicitation = false;
            state.errorCancelSolicitation = true;
        });
    },
});

export const { resetDataCancelSolicitation } = CancelQuotationSlicer.actions;
export default CancelQuotationSlicer.reducer;